/**
 * Narrow a connector's auth fields to the selected template.
 *
 * Filtering is skipped at a single template, matching every other call site in the app
 * (`ModalAddCredential`, `useConnectionAuthFields`, `getActiveItems`, …). That guard is
 * load-bearing, not incidental: a connector's field list is a union of its **local spec** fields,
 * which carry no `param_id`, and auth parameters fetched from the **API**, which do. Filtering
 * local fields against a template's parameter list drops every one of them.
 *
 * It bites on the seven migrated core connectors. Until a client opts in to server-side OAuth the
 * API omits their `auth_templates`, so there was no template here and nothing was filtered.
 * Opting in gives them exactly one — and without this guard the credential form renders empty.
 */
export function getTemplateFilteredFields(templates, items, selectedTemplateId) {
  const fields = items || [];
  if (!templates || templates.length <= 1) return fields;
  const template = templates.find((t) => t.id === selectedTemplateId) || templates[0];
  return template
    ? fields.filter((item) => template.auth_parameters.includes(item.param_id))
    : fields;
}

/**
 * Template to preselect in the credential form. Editing keeps the credential's saved template
 * even if it's no longer first; a new credential defaults to the first template, which the
 * paging reducer has already put in display order.
 */
export function getInitialTemplateId({ credential, credentialData, connAuthById }) {
  if (credential?.auth_template?.id) return credential.auth_template.id;
  if (!credentialData?.cred_type) return null;
  const connectionType = credentialData._vendorConnectionType || credentialData.cred_type;
  return connAuthById?.[connectionType]?.templates?.[0]?.id;
}
